var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0H30.827V2.72003H0V0ZM10.2757 9.52009H30.827V12.2401H10.2757V9.52009ZM0 19.0402H30.827V21.7602H0V19.0402Z","fill":"white"}));
}

MenuIcon.defaultProps = {"width":"31","height":"22","viewBox":"0 0 31 22","fill":"none"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
